import React from 'react';
import { EntityAboutCard, EntityLayout } from '@backstage/plugin-catalog';
import { Grid } from '@material-ui/core';
import { RTLCatalogGraphCard } from '../../cards/CatalogGraphCard';
import { HasSystemsCard } from '../../cards/HasSystemsCard';
import { HasServicesCard } from '../../cards/HasServicesCard/HasServicesCard';
import { WarningCard } from '../../cards/WarningCard';

export const ServicePage = () => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <WarningCard />
        <Grid item md={6}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <RTLCatalogGraphCard
            height={400}
            kinds={['Group', 'Service', 'Domain', 'System']}
          />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/services" title="Sub-Services">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12}>
          <HasServicesCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/systems" title="Systems">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12}>
          <HasSystemsCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
